import {
  createApiReducer,
  chainReducers,
  INITIAL_API_STATUS,
} from 'services/api';
import {
  AdvancedSearchItem,
  createAddSearchReducer,
  createDeleteSearchReducer,
  createFetchSearchReducer,
  createUpdateSearchReducer,
} from 'services/search';
import { combineReducers } from 'redux';

import { TaxRatesActionTypes } from './actions';

import { transformTaxRate } from '../transformations';

const initialState = {
  _status: INITIAL_API_STATUS,
  items: [],
};

/**
 * Transforms search item received from server to our format
 * @param response
 */
export const transformSearch = (serverSearchItem: any): AdvancedSearchItem => {
  return {
    id: serverSearchItem.id,
    columns: serverSearchItem.columns,
    searchName: serverSearchItem.searchName,
    isDefault: serverSearchItem.isDefault,
  };
};

const fetchTaxRatesReducer = createApiReducer(
  [
    TaxRatesActionTypes.FETCH_TAX_RATES_START,
    TaxRatesActionTypes.FETCH_TAX_RATES_SUCCESS,
    TaxRatesActionTypes.FETCH_TAX_RATES_FAILURE,
  ],
  (data) => ({ items: data.results.map(transformTaxRate) }),
  (data) => data
);

const fetchSearchReducer = createFetchSearchReducer('taxRate');
const addSearchReducer = createAddSearchReducer('taxRate');
const updateSearchReducer = createUpdateSearchReducer('taxRate');
const deleteSearchReducer = createDeleteSearchReducer('taxRate');

const taxRateChainedReducers = chainReducers(
  initialState,
  fetchTaxRatesReducer
);

const searchChainedReducers = chainReducers(
  initialState,
  fetchSearchReducer,
  addSearchReducer,
  updateSearchReducer,
  deleteSearchReducer
);

export default combineReducers({
  taxRates: taxRateChainedReducers,
  searches: searchChainedReducers,
});
